/* Stylesheet */

.letter_container {
  display: flex;
  justify-content: space-evenly;
}
